// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
/**
 * LogLevel is the severity of the log entry.
 */
export var LogLevel;
(function (LogLevel) {
    LogLevel["LOG_LEVEL_UNSPECIFIED"] = "LOG_LEVEL_UNSPECIFIED";
    LogLevel["LOG_LEVEL_INFO"] = "LOG_LEVEL_INFO";
    LogLevel["LOG_LEVEL_WARNING"] = "LOG_LEVEL_WARNING";
    LogLevel["LOG_LEVEL_ERROR"] = "LOG_LEVEL_ERROR";
})(LogLevel || (LogLevel = {}));
export var LogLevel_index;
(function (LogLevel_index) {
    LogLevel_index[LogLevel_index["LOG_LEVEL_UNSPECIFIED"] = 0] = "LOG_LEVEL_UNSPECIFIED";
    LogLevel_index[LogLevel_index["LOG_LEVEL_INFO"] = 1] = "LOG_LEVEL_INFO";
    LogLevel_index[LogLevel_index["LOG_LEVEL_WARNING"] = 2] = "LOG_LEVEL_WARNING";
    LogLevel_index[LogLevel_index["LOG_LEVEL_ERROR"] = 3] = "LOG_LEVEL_ERROR";
})(LogLevel_index || (LogLevel_index = {}));
/**
 * TerminalLogsService provides telemetry for client applications
 * connected to payment terminal devices.
 */
export const TerminalLogsService = {
    /**
     * LogTerminalEvent receives a structured terminal event log entry and stores it.
     * It returns an empty response.
     */
    LogTerminalEvent(fn, req) {
        return fn(`/payments/terminallogs`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
